import { Switch } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import { t } from "i18next";

const DatalabelsField = ({ chart, handleChange, dictionary }) => {
	const handleSwitchLabel = () => {
		handleChange("display.datalabels", !chart.display.datalabels);
	};

	return (
		<MDBox
			mt={1}
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			className="customSwitchContainer"
			onClick={() => handleSwitchLabel()}
		>
			<span>{t("SETTINGS.CHARTS.NEW.displayDatalabels")}</span>
			<MDBox>
				<Switch checked={chart.display.datalabels ?? false} />
			</MDBox>
		</MDBox>
	);
};

export default DatalabelsField;
